import { Component, OnInit, ViewChild, ChangeDetectionStrategy, TemplateRef } from '@angular/core';
import { PopupBarComponent } from 'src/app/core/components/basic/popup-bar/popup-bar.component';
import { IdCodeLabel } from 'src/app/core/models/IdCodeLabel';
import { AssociationMembreActiviteDto } from '../../models/association-membre-activite-dto';
import { AssociationMembreActivitesComponent } from '../association-membre-activites/association-membre-activites.component';

@Component({
  selector: 'app-association-membre-activites-popup',
  templateUrl: './association-membre-activites-popup.component.html',
  styleUrls: ['./association-membre-activites-popup.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AssociationMembreActivitesPopupComponent implements OnInit {
  @ViewChild(PopupBarComponent) popupBar: PopupBarComponent;
  /** Menu « Autres actions », ouvert par le bouton de l'en-tête de la fiche (#1083). */
  @ViewChild('menu', { static: true }) menu: TemplateRef<unknown>;
  // Volet F_MENU remplacé par le menu ci-dessus (#1083).
  // F_MENU = 'menu';
  F_NOUVELLE_ACTIVITE = 'nouvelleActivite';
  F_NOUVEAU_MEMBRE = 'nouveauMembre';

  constructor(public amac: AssociationMembreActivitesComponent) {}

  ngOnInit(): void {}

  // reset() {
  //   this.popupBar.reset(this.F_MENU, {});
  // }

  saisieActivite() {
    this.popupBar.reset(this.F_NOUVELLE_ACTIVITE, {});
  }

  onCreateActivite(id: number) {
    if (this.amac.membreActivites.some((v) => !v.activite?.id)) {
      // on met à jour la ligne sans activité renseignée
      const i = this.amac.membreActivites.findIndex((v) => !v.activite?.id);
      this.amac.membreActivites[i].activite.id = id;
    } else {
      // on crée une nouvelle ligne d'association membre/activité
      this.amac.membreActivites.push(
        new AssociationMembreActiviteDto({
          activite: new IdCodeLabel({ id: id }),
          actPrincipale: !this.amac.membreActivites.some((a) => a.actPrincipale),
        }),
      );
    }

    this.amac.form.get('membreActiviteList').setValue(this.amac.membreActivites);
    this.popupBar.reset('', {});
  }

  saisieMembre() {
    this.popupBar.reset(this.F_NOUVEAU_MEMBRE, {});
  }

  onCreateMembre(id: number) {
    this.amac.membreSearchor.searchById(id).then(() => {
      this.amac.form.get('id').setValue(id);
      this.amac.membreId = id;
      this.amac.membreSearchor.initSearchParam();
    });
    this.popupBar.reset('', {});
  }

  save() {}
}
